import { createSelector } from 'reselect'
import isFastDeliveryAvailableShippingSelect from 'modules/shipping/redux/selectors/is-fast-delivery-available'
import isDeliveryAvailabilityLoadedShippingSelect from 'modules/shipping/redux/selectors/is-delivery-availability-loaded'
import isDeliveryAvailableShippingSelect from 'modules/shipping/redux/selectors/is-delivery-available'
import getShortDeliveryDateLabelShippingSelectorUtil from 'modules/shipping/redux/selectors/get-short-delivery-date-label/utils'

const getShortDeliveryDateLabelShippingSelector = (props) => createSelector(
  isDeliveryAvailableShippingSelect,
  isFastDeliveryAvailableShippingSelect,
  isDeliveryAvailabilityLoadedShippingSelect,
  (
    isDeliveryAvailable,
    isFastDeliveryAvailable,
    isDeliveryAvailabilityLoaded
  ) => getShortDeliveryDateLabelShippingSelectorUtil({
    isDeliveryAvailable,
    isFastDeliveryAvailable,
    isDeliveryAvailabilityLoaded,
    ...props
  })
)

export default getShortDeliveryDateLabelShippingSelector
